//发票状态管理
import {dicInvoiceStatus, dicInvoiceType, dicInvoiceTypeNumber} from 'meibao-insure/src/util/dicList'

export const invoiceStatusOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuWidth: 120,
		delBtn: false,
		editBtn: false,
		menuAlign: 'center',
		addBtn: false,
		excelBtn: false,
		searchMenuPosition: 'right',
		searchMenuSpan: 10,
		searchLabelWidth: 120,
		column: [
			{
				label: '发票id',
				prop: 'id',
			},
			{
				label: '申请时间',
				prop: 'orderPayTime',
			},
			{
				label: '保单号',
				prop: 'policyNo',
				search: true,
			},
			{
				label: '批单号',
				prop: 'endorseNo',
				search: true,
			},
			{
				label: '被保企业/个人',
				prop: 'unitName',
				search: true,
			},
			{
				label: '开票金额',
				prop: 'money',
			},
			{
				label: '开票类型',
				prop: 'typeName',
			},
			{
				label: '开票类型',
				prop: 'type',
				hide: true,
				search: true,
				searchOrder: 1,
				type: 'select',
				dicData: dicInvoiceTypeNumber,
			},
			{
				label: '开票状态',
				prop: 'statusName',
			},
			{
				label: '开票状态',
				prop: 'status',
				hide: true,
				search: true,
				searchOrder: 1,
				type: 'select',
				dicData: dicInvoiceStatus,
			},
			{
				label: '收件人',
				prop: 'mailName',
			},
			{
				label: '快递公司',
				prop: 'mailCompanyName',
			},
			{
				label: '快递单号',
				prop: 'mailNum',
			},
			{
				label: '邮寄时间',
				prop: 'mailTime',
			},
		],
	}
}

export const invoiceListOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		delBtn: false,
		editBtn: false,
		menuAlign: 'center',
		menuWidth: 150,
		addBtn: false,
		excelBtn: false,
		labelWidth: 140,
		selection: true,
		searchLabelWidth: 120,
		selectionWidth: 100,
		reserveSelection: true,
		selectable: ({tickIfExist = -1}) => {
			return tickIfExist === 1
		},
		column: [
			{
				label: '发票id',
				prop: 'id',
			},
			{
				label: '申请时间',
				prop: 'orderPayTime',
				width: 140,
			},
			{
				label: '发票抬头',
				prop: 'title',
				width: 160,
				search: true,
			},
			{
				label: '信用代码',
				prop: 'identification',
				width: 160,
				search: true,
			},
			{
				label: '保单号',
				prop: 'policyNo',
				width: 160,
				search: true,
			},
			{
				label: '批单号',
				prop: 'endorseNo',
				width: 160,
				search: true,
			},
			{
				label: '开票类型',
				prop: 'type',
				type: 'select',
				width: 100,
				dicData: dicInvoiceType,
				search: true,
			},
			{
				label: '开票金额(元)',
				prop: 'money',
				width: 120,
			},
			{
				label: '开票状态',
				prop: 'status',
				type: 'select',
				width: 100,
				dicData: dicInvoiceStatus,
				search: true,
			},
			{
				label: '发票附件生成',
				prop: 'tickIfExist',
				width: 100,
				type: 'select',
				search: true,
				//-1 全部 1 已生成， 2未生成，
				dicData: [
					{
						label: '全部',
						value: -1,
					},
					{
						label: '已生成',
						value: 1,
					},
					{
						label: '未生成',
						value: 2,
					},
				],
			},
			{
				label: '发票变更',
				prop: 'comeSourceDes',
				width: 100,
			},
			{
				label: '快递公司',
				prop: 'mailCompanyName',
				display: false,
			},
			{
				label: '快递单号',
				prop: 'mailNum',
				display: false,
			},
			{
				label: '邮寄时间',
				prop: 'mailTime',
				display: false,
			},
			// {
			//   label: '备注',
			//   prop: 'remark',
			//   display: false,
			//   width: 200,
			// },
			{
				label: '注册地址',
				prop: 'address',
				hide: true,
			},
			{
				label: '注册电话',
				prop: 'phone',
				hide: true,
			},
			{
				label: '开户银行',
				prop: 'bankName',
				hide: true,
			},
			{
				label: '开户账号',
				prop: 'bankNo',
				hide: true,
			},

			{
				label: '收件人',
				prop: 'mailName',
			},
			{
				label: '手机号',
				prop: 'mailPhone',
				hide: true,
			},
			{
				label: '所在地区',
				prop: 'mailAreaName',
				hide: true,
			},
			{
				label: '详细地址',
				prop: 'mailAddress',
				hide: true,
			},
			{
				label: '纳税人资质证明',
				prop: 'taxCertificate',

				type: 'upload',
				listType: 'picture-img',
				hide: true,
				span: 24,
				// propsHttp: {
				//   home:'https://avuejs.com',
				// },
				tip: '只能上传jpg/png用户头像，且不超过6M',
			},
		],
	}
}

//变更原因
export function changeReason() {
	return [
		{
			//变更原因:1-保司开票有误；2-客户提供信息有误；3-
			// 审核有误；4-其他
			label: '变更原因',
			prop: 'comeReason',
			span: 24,
			type: 'select',
			rules: [
				{
					required: true,
					message: '请选择变更原因',
					trigger: 'blur',
				},
			],
			dicData: [
				{
					label: '保司开票有误',
					value: 1,
				},
				{
					label: '客户提供信息有误',
					value: 2,
				},
				{
					label: '审核有误',
					value: 3,
				},
				{
					label: '其他',
					value: 4,
				},
			],
		},
		{
			label: '发票备注',
			prop: 'remark',
			type: 'textarea',
			span: 24,
		},
	]
}
